import { useTranslation as useI18nTranslation } from 'react-i18next';
import { useCallback } from 'react';

export const useTranslation = () => {
  const { t, i18n } = useI18nTranslation();
  
  const changeLanguage = useCallback(async (language: string) => {
    try {
      await i18n.changeLanguage(language);
      localStorage.setItem('preferredLanguage', language);
      
      // Update document direction for RTL languages
      document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
      document.documentElement.lang = language;
    } catch (error) {
      console.error('Failed to change language:', error);
    }
  }, [i18n]);

  const getCurrentLanguage = useCallback(() => {
    return i18n.language;
  }, [i18n]);

  const getAvailableLanguages = useCallback(() => {
    return Object.keys(i18n.options.resources || {});
  }, [i18n]);

  return {
    t,
    i18n,
    changeLanguage,
    currentLanguage: getCurrentLanguage(),
    availableLanguages: getAvailableLanguages(),
  };
};

export default useTranslation;